import ResetPassword from "../feature/Login/ResetPassword"

const ResetPasswordPage = () => {
    return <ResetPassword />
}

export default ResetPasswordPage